import React, { useEffect, useMemo, useState } from 'react';
import { PieChartWrapper } from '../../../components/statistics/PieChartWrapper';
import DiagramsBetShop from '../diagramsBetShop';

let intervalId;

const Slider = ({ t, betShopStatistic, activeLastRound }) => {
  const slidersData = useMemo(() => {
    return [
      {
        id: 1,
        Component: ({ isActive, isShow }) => {
          if (!isActive && !isShow) {
            return null;
          }
          return (
            <PieChartWrapper isRemove={!isActive} isActive={isActive} statistics={betShopStatistic[activeLastRound]} />
          );
        },
      },
      {
        id: 2,
        Component: ({ isActive, isShow }) => {
          if (!isActive && !isShow) {
            return null;
          }
          return (
            <DiagramsBetShop
              t={t}
              isActive={isActive}
              isRemove={!isActive}
              betShopStatistic={betShopStatistic}
              activeLastRound={activeLastRound}
            />
          );
        },
      },
    ];
  }, [betShopStatistic, activeLastRound]);
  const [isActiveSlider, setIsActiveSlider] = useState(slidersData[0]);

  useEffect(() => {
    const data = [...slidersData];
    if (data.length > 1) {
      intervalId = setInterval(() => {
        const ind = slidersData.findIndex((item) => item.id === isActiveSlider.id);
        const isShowSlide = { ...data[ind] };
        data.splice(ind, 1);
        data[0].isActive = true;
        data.push(isShowSlide);
        setIsActiveSlider(data[ind]);
      }, 10000);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className='roulette-betshop-pie'>
      {betShopStatistic ? (
        <>
          {slidersData.map(({ Component, id }) => (
            <Component key={id} isShow={isActiveSlider?.isActive} isActive={id === isActiveSlider?.id} />
          ))}
        </>
      ) : null}
    </div>
  );
};
export default Slider;
